import { paymentApi } from "@store/services/apiSingleton";
import { store } from "@store/store";

export const PaymentAPI = paymentApi.injectEndpoints({
  endpoints: (builder) => ({
    createOpaquePayment: builder.query({
      query: ({ pnr, source, transactions }) => {
        const { sessionKey: session } = store.getState().session;

        const { api_agency: agency, payment_api_path: payment_path } = store.getState().environment;

        return {
          url: payment_path,
          method: "POST",
          body: {
            agency,
            pnr,
            session,
            source,
            transactions,
          },
        };
      },
    }),
    createPaymentIntent: builder.query({
      query: ({ pnr, transactions, source }) => {
        const { sessionKey: session } = store.getState().session;

        return {
          url: "/initiate-payment/",
          method: "POST",
          body: {
            pnr,
            session,
            transactions,
            source,
          },
        };
      },
    }),
  }),
});

export const { useLazyCreateOpaquePaymentQuery, useLazyCreatePaymentIntentQuery } = PaymentAPI;
